import { render, staticRenderFns } from "./HUDUserForests.vue?vue&type=template&id=e71a724c&scoped=true&"
import script from "./HUDUserForests.vue?vue&type=script&lang=ts&"
export * from "./HUDUserForests.vue?vue&type=script&lang=ts&"
import style0 from "./HUDUserForests.vue?vue&type=style&index=0&id=e71a724c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71a724c",
  null
  
)

export default component.exports